import { useParams } from 'react-router-dom';

import { ConnectedCarModelsTable } from 'features/car-model/table';

export function CarBrandModelsListPage() {
  const { carBrandId } = useParams() as { carBrandId: string };

  return <ConnectedCarModelsTable carBrandId={carBrandId} />;
}
